import { render } from "./PropertyTitle.vue?vue&type=template&id=76460156&scoped=true"
import script from "./PropertyTitle.vue?vue&type=script&lang=js"
export * from "./PropertyTitle.vue?vue&type=script&lang=js"

import "./PropertyTitle.vue?vue&type=style&index=0&id=76460156&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76460156"]])

export default __exports__